import React, { useState, useEffect, useCallback } from "react";
import Spiner from "../../components/General/Spiner";
import ConfiguracionLogic from "../../functions/logic/Configuracion";
import PowerBIReport from "../../components/General/BIEmbed";

const TableroDetailsBI = () => {
    const [spiner, setSpiner] = useState(false);
    const [nombreBi, setNombreBi] = useState("");
    const [descBi, setDescBi] = useState("");
    const [token, setToken] = useState("");
    const [tokenId, setTokenId] = useState("");
    const [idReport, setIdReport] = useState("");
    const [urlReport, setUrlReport] = useState("");
    const [urlEmbeded, setUrlEmbeded] = useState("");

    const showBi = useCallback(async () => {
        setSpiner(true);
        if (
            localStorage.getItem("urlTableroBi") &&
            localStorage.getItem("urlTableroBi")
        ) {
            const resp = await ConfiguracionLogic.tableroLogic(
                localStorage.getItem("idTableoBI"),
                1,
                5,
                ""
            );

            setIdReport(resp.data.idReporte);
            setUrlReport(resp.data.urlReporte);
            setUrlEmbeded(resp.data.urlEmbedded);
            const tokenData = await ConfiguracionLogic.getTokenBI(
                resp.data.idDataset,
                resp.data.idReporte
            );
            if (tokenData && tokenData.data) {
                if (tokenData.success && tokenData.code === 200) {
                    setToken(tokenData.data.token);
                    setTokenId(tokenData.data.tokenId);
                }
            }

            setNombreBi(localStorage.getItem("nombreBI"));
            setDescBi(localStorage.getItem("descripcionBI"));
        }
        setTimeout(function () {
            setSpiner(false);
        }, global.DELAY_DASH);
    }, []);

    useEffect(() => {
        showBi();
    }, [showBi]);

    const handleRedirectBack = (item) => {
        localStorage.removeItem("nombreBI");
        localStorage.removeItem("descripcionBI");
        localStorage.removeItem("urlTableroBi")
        if (localStorage.getItem("pageOp") === '1') {
            window.location.href = global.TABLERO_DETAIL;
        } else {
            localStorage.setItem('returnBiDEtail', 1)
            window.location.href = global.TABLERO_DETAIL_ALL;
        }
    };

    return (
        <div className="content-wrapper">
            <Spiner opt={spiner} />
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <button className="btn btn-default" onClick={handleRedirectBack}>
                                <i className="fas fa-arrow-left"></i> Regresar al listado de
                                tableros
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">Tablero {nombreBi}</li>
                                <li className="breadcrumb-item">{descBi}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container-fluid">
                <div className="row no-gutters">
                    <PowerBIReport
                        token={token}
                        tokenId={tokenId}
                        idReport={idReport}
                        urlReport={urlEmbeded}
                    />
                </div>
            </div>

            {/*<div className="container-fluid">
                <div className="row no-gutters">
                    <div className="col-md-3 mb-3">
                        <div className="info-box rounded-box">
                            <span className="info-box-icon bg-warning elevation-1 rounded-icon">
                                <i className="far fa-building"></i>
                            </span>
                            <div className="info-box-content">
                                <span className="info-box-text text-blue">Asume empresa</span>
                                <span className="info-box-number">$12.750</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 mb-3"> 
                        <div className="info-box rounded-box">
                            <span className="info-box-icon bg-info elevation-1">
                                <i className="fas fa-comment-dollar"></i>
                            </span>
                            <div className="info-box-content">
                                <span className="info-box-text">V. Servicio</span>
                                <span className="info-box-number">$41,410</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 mb-3"> 
                        <div className="info-box rounded-box">
                            <span className="info-box-icon bg-warning elevation-1">
                                <i className="fas fa-file-invoice-dollar"></i>
                            </span>
                            <div className="info-box-content">
                                <span className="info-box-text">Asume Cliente</span>
                                <span className="info-box-number">$3,460</span>
                            </div>
                        </div>
                    </div>

                   
                        <div className="col-md-3 mb-3"> {/* Margen inferior para separación
                                    <div className="info-box rounded-box">
                                        <span className="info-box-icon bg-info elevation-1">
                                            <i className="fas fa-users"></i>
                                        </span>
                                        <div className="info-box-content">
                                            <span className="info-box-text">Paciente</span>
                                            <span className="info-box-number">$2,000</span>
                                        </div>
                                    </div>
                                </div>
                        

                    <div className="col-md-3 mb-3"> 
                        <div className="info-box rounded-box">
                            <span className="info-box-icon bg-success elevation-1">
                                <i className="fas fa-dollar-sign"></i>
                            </span>
                            <div className="info-box-content">
                                <span className="info-box-text">Total</span>
                                <span className="info-box-number">$2,454,000</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card">
                                <div className="card-header border-0">
                                    <div className="d-flex justify-content-between">
                                        <h3 className="card-title">Mobilidad</h3>
                                        <a href="!#">View Report</a>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex">
                                        <p className="d-flex flex-column">
                                            <span className="text-bold text-lg">820</span>
                                            <span>Visitors Over Time</span>
                                        </p>
                                        <p className="ml-auto d-flex flex-column text-right">
                                            <span className="text-success">
                                                <i className="fas fa-arrow-up"></i> 12.5%
                                            </span>
                                            <span className="text-muted">Since last week</span>
                                        </p>
                                    </div>


                                    <div className="position-relative mb-4">
                                        <canvas id="visitors-chart" height="200"></canvas>
                                    </div>

                                    <div className="d-flex flex-row justify-content-end">
                                        <span className="mr-2">
                                            <i className="fas fa-square text-primary"></i> This Week
                                        </span>

                                        <span>
                                            <i className="fas fa-square text-gray"></i> Last Week
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card">
                                <div className="card-header border-0">
                                    <div className="d-flex justify-content-between">
                                        <h3 className="card-title">Sales</h3>
                                        <a href="!#">View Report</a>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex">
                                        <p className="d-flex flex-column">
                                            <span className="text-bold text-lg">$18,230.00</span>
                                            <span>Sales Over Time</span>
                                        </p>
                                        <p className="ml-auto d-flex flex-column text-right">
                                            <span className="text-success">
                                                <i className="fas fa-arrow-up"></i> 33.1%
                                            </span>
                                            <span className="text-muted">Since last month</span>
                                        </p>
                                    </div>

                                    <div className="position-relative mb-4">
                                        <canvas id="sales-chart" height="200"></canvas>
                                    </div>

                                    <div className="d-flex flex-row justify-content-end">
                                        <span className="mr-2">
                                            <i className="fas fa-square text-primary"></i> This year
                                        </span>

                                        <span>
                                            <i className="fas fa-square text-gray"></i> Last year
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header border-0">
                                    <h3 className="card-title">Products</h3>
                                    <div className="card-tools">
                                        <a href="!#" className="btn btn-tool btn-sm">
                                            <i className="fas fa-download"></i>
                                        </a>
                                        <a href="!#" className="btn btn-tool btn-sm">
                                            <i className="fas fa-bars"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-striped table-valign-middle">
                                        <thead>
                                            <tr>
                                                <th>Nivel 2</th>
                                                <th>Pac</th>
                                                <th>Ate</th>
                                                <th>Valor Servicio</th>
                                                <th>Asume cliente</th>
                                                <th>Asume empresa</th>
                                                <th>FR</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    BMI
                                                </td>
                                                <td>$13 USD</td>
                                                <td>$133423 USD</td>
                                                <td>$13442 USD</td>
                                                <td>$144323 USD</td>
                                                <td>$1233 USD</td>
                                                <td>$12343 USD</td>
                                                <td>
                                                    <button className="btn btn-default">Descargar</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>*/}
        </div>
    );
};

export default TableroDetailsBI;
